import { React, useState, useRef, useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import Preloader from '../components/Preloader';
import Footer from '../components/Footer'; import { FaEye, FaBullseye, FaLaptop, FaGlobeAfrica, FaHeart } from 'react-icons/fa';
import styles from '../styles/autoslider.module.css';
import ScrollReveal from '../components/ScrollReveal';
import { Helmet } from 'react-helmet';

const teamMembers = [
    {
        name: 'fullname',
        role: 'Chief Executive Officer',
        image: '../assets/avatar.jpg',
        bio: 'With a passion for travel and technology, Kofi founded Vrify Ghana to share the beauty of his homeland with the world.'
    },
    {
        name: 'fullname',
        role: 'Marketing Manager',
        image: '../assets/avatar.jpg',
        bio: 'Ama is a certified tour guide with over 15 years of experience exploring every corner of Ghana.'
    },
    {
        name: 'fullname',
        role: 'Technical Manager',
        image: '../assets/avatar.jpg',
        bio: 'Yaw brings our virtual tours to life with his expertise in immersive web technologies.'
    },
];

const features = [
    {
        icon: <FaEye className="text-green-600 text-4xl mb-4" />,
        title: 'Immersive Experience',
        description: 'Our 360° virtual tours provide a deeply engaging experience, making you feel like you’re really there.'
    },
    {
        icon: <FaGlobeAfrica className="text-green-600 text-4xl mb-4" />,
        title: 'Authentic Culture',
        description: 'We partner with local guides and communities to offer genuine insights into Ghanaian life and traditions.'
    },
    {
        icon: <FaLaptop className="text-green-600 text-4xl mb-4" />,
        title: 'Accessible Anywhere',
        description: 'Explore Ghana from the comfort of your home, on any device, at any time.'
    },
    {
        icon: <FaHeart className="text-green-600 text-4xl mb-4" />,
        title: 'Passion-Driven',
        description: 'We are a team of passionate individuals dedicated to showcasing the best of Ghana.'
    }
];

const AboutUs = () => {

    // partner slider
    // partner slider
    // At the top of your Home component:
    const sliderRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);

    const slides = [
        { src: "../assets/bellaircrestlogo.png", alt: "partner logo" },
        { src: "../assets/bridgeviewhotel.png", alt: "partner logo" },
        { src: "../assets/bellaircrestlogo.png", alt: "partner logo" },
        { src: "../assets/bridgeviewhotel.png", alt: "partner logo" },
        { src: "../assets/bellaircrestlogo.png", alt: "partner logo" },
        { src: "../assets/bridgeviewhotel.png", alt: "partner logo" },
        { src: "../assets/bellaircrestlogo.png", alt: "partner logo" },
        { src: "../assets/bridgeviewhotel.png", alt: "partner logo" },
        { src: "../assets/bellaircrestlogo.png", alt: "partner logo" },
        { src: "../assets/bridgeviewhotel.png", alt: "partner logo" },

        // ...add all your slides here...
    ];

    // Duplicate slides for seamless looping
    const loopSlides = [...slides, ...slides, ...slides, ...slides, ...slides, ...slides,];

    // Manual drag handlers (mouse/touch)
    function handleMouseDown(e) {
        setIsDragging(true);
        setStartX(e.pageX - sliderRef.current.offsetLeft);
        setScrollLeft(sliderRef.current.scrollLeft);
    }
    function handleMouseLeave() {
        setIsDragging(false);
    }
    function handleMouseUp() {
        setIsDragging(false);
    }
    function handleMouseMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX) * 1.5;
        sliderRef.current.scrollLeft = scrollLeft - walk;
    }
    function handleTouchStart(e) {
        setIsDragging(true);
        setStartX(e.touches[0].pageX - sliderRef.current.offsetLeft);
        setScrollLeft(sliderRef.current.scrollLeft);
    }
    function handleTouchEnd() {
        setIsDragging(false);
    }
    function handleTouchMove(e) {
        if (!isDragging) return;
        const x = e.touches[0].pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX) * 1.5;
        sliderRef.current.scrollLeft = scrollLeft - walk;
    }

    // Set initial scroll position to the middle set for seamless looping
    useEffect(() => {
        if (sliderRef.current) {
            const slideWidth = 250 + 30; // 250px width + 2*15px padding
            sliderRef.current.scrollLeft = slides.length * slideWidth;
        }
    }, [slides.length]);

    // Infinite loop logic on scroll
    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider) return;
        const slideWidth = 250 + 30;
        const totalSlides = slides.length;
        const totalLoopSlides = loopSlides.length;

        const handleScroll = () => {
            const maxScroll = slideWidth * (totalLoopSlides - totalSlides);
            if (slider.scrollLeft <= 0) {
                // Jump forward to the same slide in the middle set
                slider.scrollLeft = slideWidth * totalSlides;
            } else if (slider.scrollLeft >= maxScroll) {
                // Jump back to the same slide in the middle set
                slider.scrollLeft = slideWidth * totalSlides;
            }
            // Update current index for indicators/buttons
            const idx = Math.round(slider.scrollLeft / slideWidth) % totalSlides;
            setCurrentIndex(idx);
        };
        slider.addEventListener("scroll", handleScroll);
        return () => slider.removeEventListener("scroll", handleScroll);
    }, [slides.length, loopSlides.length]);
    // Scroll to a specific slide (in the middle set)
    const scrollToSlide = (idx) => {
        if (!sliderRef.current) return;
        const slideWidth = 250 + 30;
        sliderRef.current.scrollTo({
            left: (slides.length + idx) * slideWidth,
            behavior: "smooth",
        });
    };

    // Next/Prev button handlers (looping)
    const goToPrev = () => {
        scrollToSlide((currentIndex - 1 + slides.length) % slides.length);
    };
    const goToNext = () => {
        scrollToSlide((currentIndex + 1) % slides.length);
    };

    return (
        <div className='font-nixie-one bg-white min-h-screen text-gray-800'>
            <Helmet>
                <title>About Us | VRIFY Africa</title>
                <meta name="description" content="Learn more about VRIFY Africa, our mission, and how we are transforming the way people experience spaces in Ghana." />
            </Helmet>
            <PageHeader />
            <Preloader />
            <main>
                {/* Hero Section */}
                <section className="relative h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/ghana-header.jpg')" }}>
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                        <div className="text-center text-white">
                            <h1 className="text-5xl md:text-6xl font-cormorant-upright font-bold">About Vrify Africa</h1>
                            <p className="mt-4 text-lg md:text-sm">Bringing Africa's Wonders to Your Screen, Get to us more...</p>
                        </div>
                    </div>
                </section>

                {/* Our Story Section */}
                <section className="py-20 px-4 container mx-auto">
                    <div className="max-w-3xl mx-auto text-center">
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                            <h2 className="text-4xl font-semibold text-gray-800 font-cormorant-upright mb-6">Our Story</h2>
                            <hr className="w-8 border-2 border-black rounded-md mx-auto mb-8" />
                        </ScrollReveal>
                        <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={400}>
                            <p className="text-gray-600 font-semibold leading-relaxed text-base">
                                Vrify Ghana was born from a deep love for Ghana's rich culture, breathtaking landscapes, and vibrant history. We wanted to create a platform that allows everyone, no matter where they are in the world, to experience the magic of Ghana. Using cutting-edge virtual tour technology, we bring the sights and sounds of our beautiful country directly to you, creating connections and inspiring future travel.
                            </p>
                        </ScrollReveal>
                    </div>
                </section>

                {/* Mission & Vision Section */}
                <section className="bg-gray-50 py-20 px-4">
                    <div className="container mx-auto lg:px-28 grid md:grid-cols-2 lg:grid-cols-3 gap-12 items-start font-semibold">
                        <ScrollReveal animationClass="animate-slide-left" threshold={0.1} delay={200}>
                            <div className="text-center md:text-left">
                                <FaBullseye className="text-5xl text-green-600 mx-auto md:mx-0 mb-4" />
                                <h3 className="text-3xl font-semibold font-cormorant-upright mb-3">Our Mission</h3>
                                <p className="text-gray-600 text-sm">To make Ghana's rich cultural and natural heritage accessible to a global audience through immersive and educational virtual experiences.</p>
                            </div>
                        </ScrollReveal>
                        <ScrollReveal animationClass="animate-slide-left" threshold={0.1} delay={200}>
                            <div className="text-center md:text-left">
                                <FaEye className="text-5xl text-green-600 mx-auto md:mx-0 mb-4" />
                                <h3 className="text-3xl font-semibold font-cormorant-upright mb-3">Our Vision</h3>
                                <p className="text-gray-600 text-sm">To be the leading platform for virtual tourism in Africa, connecting people to places and cultures in a sustainable and innovative way.</p>
                            </div>
                        </ScrollReveal>
                        <ScrollReveal animationClass="animate-slide-left" threshold={0.1} delay={200}>
                            <div className="text-center md:text-left md:col-span-2 lg:col-span-1">
                                <FaHeart className="text-5xl text-green-600 mx-auto md:mx-0 mb-4" />
                                <h3 className="text-3xl font-semibold font-cormorant-upright mb-3">Our Core Values</h3>
                                <p className="text-gray-600 text-sm">Authenticity, innovation, and sustainability are the pillars of our work. We are dedicated to creating respectful and impactful experiences.</p>
                            </div>
                        </ScrollReveal>
                    </div>
                </section>

                {/* Why Choose Us Section */}
                <section className="py-20 px-4">
                    <div className="container mx-auto text-center">
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                            <h2 className="text-4xl font-semibold text-gray-800 font-cormorant-upright mb-6">Why Choose Vrify Ghana</h2>
                            <hr className="w-8 border-2 border-black rounded-md mx-auto mb-8" />
                        </ScrollReveal>
                        <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={400}>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:px-28">
                                {features.map((feature, index) => (
                                    <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                                        {feature.icon}
                                        <h4 className="text-xl font-bold mb-2">{feature.title}</h4>
                                        <p className="text-gray-600 font-semmibold text-sm">{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </ScrollReveal>
                    </div>
                </section>

                {/* Meet the Team Section */}
                {/* <section className="bg-gray-50 py-20 px-4 md:px-10 lg:px-40">
                    <div className="container mx-auto text-center">
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                            <h2 className="text-4xl font-semibold text-gray-800 font-cormorant-upright mb-6">Meet the Team</h2>
                            <hr className="w-8 border-2 border-black rounded-md mx-auto mb-8" />
                        </ScrollReveal>
                        <ScrollReveal animationClass="animate-slide-left" threshold={0.1} delay={200}>
                            <div className="grid grid-cols-1 md:grid-cols-3 items-center justify-center gap-4">
                                {teamMembers.map((member, index) => (
                                    <div key={index} className="flex flex-col items-center">
                                        <img src={member.image} alt={member.name} className="w-40 h-40 rounded-full object-cover mb-4 shadow-lg" />
                                        <h4 className="text-xl font-bold">{member.name}</h4>
                                        <p className="text-green-600 font-semibold mb-2">{member.role}</p>
                                        <p className="text-gray-600 font-semibold text-justify px-20 text-sm">{member.bio}</p>
                                        <div className='flex flex-row items-center gap-3 pt-2'>
                                            <FaLinkedin className="text-base text-gray-500 hover:text-green-600" />
                                            <FaInstagram className="text-base text-gray-500 hover:text-green-600" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </ScrollReveal>
                    </div>
                </section> */}

                {/* Our Partners Section */}
                <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                    <div className="py-2 px-4 text-center container mx-auto">
                        <h2 className="text-4xl font-semibold text-gray-800 font-cormorant-upright mb-2">Our Cherished Clients</h2>
                        <hr className="w-8 border-2 border-black rounded-md mx-auto mb-8" />
                    </div>
                </ScrollReveal>
                <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={400}>
                    <div className={styles.container + " w-full px-2 sm:px-4 md:px-8 lg:px-16 xl:px-32"} style={{ position: "relative" }}>
                        <div className={styles.row} style={{ position: "relative" }}>
                            {/* Prev Button */}
                            <button
                                onClick={goToPrev}
                                aria-label="Previous"
                                className="absolute left-0 top-1/2 z-10 -translate-y-1/2 bg-green-400 hover:bg-green-700 text-white rounded-full w-10 h-10 flex items-center justify-center shadow transition-all duration-200"
                                style={{ opacity: 0.85 }}
                            >
                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <div
                                className={styles.firstsliding}
                                ref={sliderRef}
                                style={{ cursor: isDragging ? "grabbing" : "grab", position: "relative" }}
                                onMouseDown={handleMouseDown}
                                onMouseLeave={handleMouseLeave}
                                onMouseUp={handleMouseUp}
                                onMouseMove={handleMouseMove}
                                onTouchStart={handleTouchStart}
                                onTouchEnd={handleTouchEnd}
                                onTouchMove={handleTouchMove}
                                tabIndex={0}
                            >
                                <div className={styles.firstslidetrack} style={{ width: `calc(250px * ${loopSlides.length})` }}>
                                    {loopSlides.map((slide, idx) => (
                                        <div className={styles.firstslide} key={idx}>
                                            <img src={slide.src} alt={slide.alt} loading="lazy" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* Next Button */}
                            <button
                                onClick={goToNext}
                                aria-label="Next"
                                className="absolute right-0 top-1/2 z-10 -translate-y-1/2 bg-green-400 hover:bg-green-700 text-white rounded-full w-10 h-10 flex items-center justify-center shadow transition-all duration-200"
                                style={{ opacity: 0.85 }}
                            >
                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </ScrollReveal>
            </main>
            <Footer />
        </div>
    )
}

export default AboutUs;